import {IPlatformApiProvider} from '@shared/services/platform-api-provider';
import {Api} from '@shared/constants/common-field.constants';

export class ExpertServicesApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/expert-services')) {
      return Api.MarketPlace;
    }
    return '';
  }

}
